import React from 'react';

const SizeShoes = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_4217_155)">
            <g clipPath="url(#clip1_4217_155)">
                <path
                    d="M2 15.5H22"
                    stroke="#323232"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 11.5L16.8398 11.7403C16.2922 12.5617 16 13.5267 16 14.5139V15.5"
                    stroke="#323232"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 11.5L19.2985 11.7299C20.0388 11.8039 20.7251 12.1503 21.2243 12.702C21.7236 13.2536 22 13.971 22 14.715V16C22 16.5304 21.7893 17.0391 21.4142 17.4142C21.0391 17.7893 20.5304 18 20 18H4C3.46957 18 2.96086 17.7893 2.58579 17.4142C2.21071 17.0391 2 16.5304 2 16V11.5C2 11.1852 2.09906 10.8783 2.28314 10.6229C2.46722 10.3675 2.72699 10.1765 3.02566 10.077C3.32433 9.97742 3.64675 9.97436 3.94725 10.0682C4.24775 10.1621 4.51111 10.3481 4.7 10.6C4.79315 10.7242 4.91393 10.825 5.05279 10.8944C5.19164 10.9639 5.34475 11 5.5 11H7.26393C7.63535 11 7.99944 10.8966 8.3154 10.7013C8.63135 10.506 8.88668 10.2266 9.05279 9.89443L9.44721 9.10557C9.61332 8.77336 9.86865 8.49396 10.1846 8.2987C10.5006 8.10343 10.8646 8 11.2361 8H11.2998C11.7286 8 12.147 8.13102 12.4992 8.37551L17 11.5Z"
                    stroke="#323232"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_4217_155">
                <rect width="24" height="24" fill="white" />
            </clipPath>
            <clipPath id="clip1_4217_155">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default SizeShoes;
